/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarContact_viewer = {
    readonly isContactSupportEnabled?: boolean | null;
    readonly isMessageCenterEnabled?: boolean | null;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedContactSellerButton_viewer" | "PdpSharedContactDealerButton_viewer">;
    readonly " $refType": "PdpRespSidebarContact_viewer";
};
export type PdpRespSidebarContact_viewer$data = PdpRespSidebarContact_viewer;
export type PdpRespSidebarContact_viewer$key = {
    readonly " $data"?: PdpRespSidebarContact_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSidebarContact_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "fetchPdp"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarContact_viewer",
  "selections": [
    {
      "condition": "fetchPdp",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "isContactSupportEnabled",
          "args": [
            {
              "kind": "Literal",
              "name": "featureName",
              "value": "CONTACT_1STDIBS"
            }
          ],
          "kind": "ScalarField",
          "name": "isEnabledByLocale",
          "storageKey": "isEnabledByLocale(featureName:\"CONTACT_1STDIBS\")"
        },
        {
          "alias": "isMessageCenterEnabled",
          "args": [
            {
              "kind": "Literal",
              "name": "featureName",
              "value": "MESSAGE_CENTER"
            }
          ],
          "kind": "ScalarField",
          "name": "isEnabledByLocale",
          "storageKey": "isEnabledByLocale(featureName:\"MESSAGE_CENTER\")"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpSharedContactSellerButton_viewer"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpSharedContactDealerButton_viewer"
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = 'ccc7c5ddf98636fb820be0aae68e1094';
export default node;
